import { supabase } from "@/integrations/supabase/client";

export async function notifyDiscussionReply({
  discussionId,
  discussionType,
  replyContent,
  replyAuthorId,
  discussionTitle,
}: {
  discussionId: string;
  discussionType: "course" | "general" | "mentor";
  replyContent: string;
  replyAuthorId: string;
  discussionTitle: string;
}) {
  try {
    // Get author name for the email
    const { data: profile } = await supabase
      .from("profiles")
      .select("full_name")
      .eq("id", replyAuthorId)
      .single();

    const replyAuthorName = profile?.full_name || "A member";

    // Call the edge function (fire and forget - don't block the reply)
    supabase.functions.invoke("notify-discussion-reply", {
      body: {
        discussionId,
        discussionType,
        replyContent,
        replyAuthorId,
        replyAuthorName,
        discussionTitle,
      },
    }).then(({ error }) => {
      if (error) {
        console.error("Error sending discussion reply notification:", error);
      }
    });
  } catch (error) {
    console.error("Error preparing discussion reply notification:", error);
  }
}